import { zollBaseURL } from '../../../services/api.service'
import { ZollAPIService } from '../../../services/zollApi.service'
import { IZollSupportTicketRequest, IZollSupportTicketResponse } from '../store/zollSupportTicket.types'

const zollSupportTicketUrl = `${zollBaseURL}/api/ZollSupportTicket/create`

export class ZollSupportTicketService extends ZollAPIService {
  async createZollSupportTicket(data: IZollSupportTicketRequest): Promise<IZollSupportTicketResponse> {
    return this.postWithError(zollSupportTicketUrl, data)
  }
}
